export const CONTENT_TYPES = {
  PRICE: 'price',
  BULLET: 'bullet',
  TEXT: 'text',
};

export const CLOSABLE_TYPE = 'closable';
